import { Download } from "@mui/icons-material";
import { Chip } from "@mui/material";
import { useCallback } from "react";
import { useDownloadDocumentQuery } from "../../../redux/Documents/documentSlice";

type Props = {
  name: string;
};

const DownloadFileChip = ({ name }: Props) => {
  const extractedFileName = name.split("/").pop();
  const { data, isLoading } = useDownloadDocumentQuery({
    fileName: extractedFileName || "",
  });
  const openFile = useCallback(() => {
    window.open(data?.link, "_blank");
  }, [data?.link]);

  return (
    <Chip
      label={extractedFileName}
      onClick={openFile}
      icon={<Download color="inherit" fontSize="small" />}
      disabled={isLoading}
      sx={{
        backgroundColor: "#f0f0f0",
        opacity: isLoading ? 0.6 : 1,
        fontSize: 14,
        border: "none",
        color: "#000",
      }}
    />
  );
};

export default DownloadFileChip;
